import { type IconProps, iconVariants } from '@/components/icons/common'

export function WalletIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      role="presentation"
      className={iconVariants({ size, className })}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4H18C20.2091 4 22 5.79086 22 8H18C15.7909 8 14 9.79086 14 12C14 14.2091 15.7909 16 18 16L22 16C22 18.2091 20.2091 20 18 20H6C3.79086 20 2 18.2091 2 16V8C2 5.79086 3.79086 4 6 4ZM7.1233 7.2602C6.71472 7.19211 6.3283 7.46812 6.2602 7.8767C6.19211 8.28528 6.46812 8.6717 6.8767 8.7398L9.2191 9.1302C9.73614 9.21637 10.2639 9.21637 10.7809 9.1302L13.1233 8.7398C13.5319 8.6717 13.8079 8.28528 13.7398 7.8767C13.6717 7.46812 13.2853 7.19211 12.8767 7.2602L10.5343 7.65061C10.1805 7.70956 9.81946 7.70956 9.4657 7.65061L7.1233 7.2602Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 14.5H18C16.6193 14.5 15.5 13.3807 15.5 12C15.5 10.6193 16.6193 9.5 18 9.5H22V14.5ZM17.25 12C17.25 11.5858 17.5858 11.25 18 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H18C17.5858 12.75 17.25 12.4142 17.25 12Z"
      />
    </svg>
  )
}
